<template>
  <v-card class="pa-8">
    <v-overlay v-model="settingFilters">
      <v-progress-circular indeterminate size="32" />
    </v-overlay>
    <v-card-title
      v-if="areSettingsEmpty"
      class="error--text d-flex flex-column justify-center align-center"
    >
      <v-icon color="error">mdi-alert</v-icon>
      <span>Você não selecionou nenhum item nas configurações</span>
      <p class="primary--text">
        Clique no botão <v-icon>mdi-cog</v-icon> para configurar os filtros
      </p>
    </v-card-title>
    <validation-observer v-else-if="!settingFilters" v-slot="{ invalid }">
      <v-card-subtitle class="error--text"
        >Todos os campos abaixo são obrigatórios</v-card-subtitle
      >
      <v-card-text>
        
        <servico-list-filtro-modal-item title="Gate" v-if="!empresaAtual.gate">
          <template #items>
            <v-col>
              <validation-provider
                name="gate"
                rules="required"
                v-slot="{ errors }"
              >
                <v-autocomplete
                  v-model="params.gate.value"
                  label="Gate"
                  prepend-icon="mdi-domain"
                  :items="gates"
                  :item-text="(item) => `${item.business_name} - ${item.cnpj}`"
                  item-value="public_id"
                  :error-messages="errors"
                />
              </validation-provider>
            </v-col>
          </template>
        </servico-list-filtro-modal-item>

        <servico-list-filtro-modal-item title="Data" v-if="showData">
          <template #items>
            <v-col v-if="params.data_inicio && params.data_inicio.visible">
              <validation-provider
                name="data início"
                v-slot="{ errors }"
                rules="required"
              >
                <conferencia-list-filtro-data
                  propLabel="De"
                  v-model="params.data_inicio.value"
                  :errors="errors"
                  v-mask="['##/##/#### ##:##']"
                />
              </validation-provider>
            </v-col>
            <v-col v-if="params.data_fim && params.data_fim.visible">
              <validation-provider
                name="data fim"
                v-slot="{ errors }"
                rules="required"
                v-mask="['##/##/#### ##:##']"
              >
                <conferencia-list-filtro-data
                  propLabel="Até"
                  v-model="params.data_fim.value"
                  :errors="errors"
                />
              </validation-provider>
            </v-col>
          </template>
        </servico-list-filtro-modal-item>

        <servico-list-filtro-modal-item
          title="Fornecedor"
          v-if="showFornecedor"
        >
          <template #items>
            <servico-list-filtro-modal-item-input-fornecedor
              v-if="params.fornecedor_field && params.fornecedor_field.visible"
              v-model="params.fornecedor_field.value"
              name="fornecedor"
              label="Fornecedor"
              icon="mdi-account-child"
              rules="required"
            />
            <servico-list-filtro-modal-item-input-produtos
              v-if="params.produto && params.produto.visible"
              v-model="params.produto.value"
              name="produto"
              label="Produto"
              icon="mdi-corn"
              rules="required"
              :fornecedor="selectedFornecedor"
            />
            <servico-list-filtro-modal-item-input-sub-produtos
              v-if="params.sub_produto && params.sub_produto.visible"
              v-model="params.sub_produto.value"
              name="sub produto"
              label="Sub Produto"
              icon="mdi-corn"
              rules="required"
              :produto="selectedProduto"
            />
          </template>
        </servico-list-filtro-modal-item>

        <servico-list-filtro-modal-item title="Contratos" v-if="showContratos">
          <template #items>
            <v-autocomplete
              v-if="params.colaborador && params.colaborador.visible"
              v-model="params.colaborador.value"
              label="Colaborador"
              prepend-icon="mdi-domain"
              :items="colaboradores"
              item-text="user.name"
              item-value="public_id"
            />
            <servico-list-filtro-modal-item-input-terminal
              v-if="params.terminal && params.terminal.visible"
              v-model="params.terminal.value"
              name="terminal"
              label="Terminal"
              icon="mdi-mailbox"
              rules="required"
            />
            <servico-list-filtro-modal-item-input
              v-if="params.armazem && params.armazem.visible"
              v-model="params.armazem.value"
              name="armazem"
              label="Armazem"
              icon="mdi-cart"
              rules="required"
            />
            <servico-list-filtro-modal-item-input-cliente
              v-if="params.cliente && params.cliente.visible"
              v-model="params.cliente.value"
              name="cliente"
              label="Cliente"
              icon="mdi-mailbox"
              rules="required"
            />
            <servico-list-filtro-modal-item-input-transportadoras
              v-if="params.transportadora && params.transportadora.visible"
              v-model="params.transportadora.value"
              name="transportadora"
              label="Transportadora"
              icon="mdi-bag-carry-on"
            />
            <servico-list-filtro-modal-item-servicos
              v-if="params.servico && params.servico.visible"
              v-model="params.servico.value"
              name="servico"
              label="Serviços"
              icon="mdi-home-city"
              rules="required"
            />
            <servico-list-filtro-modal-item-input-status
              v-if="params.status && params.status.visible"
              v-model="params.status.value"
              name="status"
              label="Visualizar serviços Cancelados"
              icon="mdi-home-city"
              rules="required"
            />
            <servico-list-filtro-modal-item-input-status
              v-if="
                params.status_agendamento && params.status_agendamento.visible
              "
              v-model="params.status_agendamento.value"
              name="status_agendamento"
              label="Visualizar agendamentos Cancelados"
              icon="mdi-home-city"
              rules="required"
            />
          </template>
        </servico-list-filtro-modal-item>

        <servico-list-filtro-modal-item title="Região" v-if="showRegiao">
          <template #items>
            <servico-list-filtro-modal-item-input
              v-if="params.regiao && params.regiao.visible"
              v-model="params.regiao.value"
              name="regiao"
              label="Região"
              icon="mdi-home-city"
              rules="required"
            />
            <servico-list-filtro-modal-item-input
              v-if="params.representante && params.representante.visible"
              v-model="params.representante.value"
              name="representante"
              label="Representante (CPF)"
              icon="mdi-face-agent"
              rules="cpfValido|required"
              mask="###.###.###-##"
            />
          </template>
        </servico-list-filtro-modal-item>

        <servico-list-filtro-modal-item title="Veículo" v-if="showVeiculo">
          <template #items>
            <servico-list-filtro-modal-item-input
              v-if="params.motorista && params.motorista.visible"
              v-model="params.motorista.value"
              name="motorista"
              label="Motorista (CPF)"
              icon="mdi-card-account-details"
              rules="cpfValido|required"
              mask="###.###.###-##"
            />
            <servico-list-filtro-modal-item-input
              v-if="params.placa_cavalo && params.placa_cavalo.visible"
              v-model="params.placa_cavalo.value"
              name="placa cavalo"
              label="Placa Cavalo"
              icon="mdi-truck"
              mask="AAA-XXXX"
              :rules="{
                min: 8,
                required: true,
              }"
            />
            <servico-list-filtro-modal-item-input
              v-if="params.eixo && params.eixo.visible"
              v-model="params.eixo.value"
              name="eixo"
              label="Eixo"
              icon="mdi-truck"
              :rules="{
                min_value: 1,
                required: true,
              }"
            />
          </template>
        </servico-list-filtro-modal-item>


        <servico-list-filtro-modal-item title="Forma de pagamento" v-if="showFormaPgto">
          <template #items>
            <servico-list-filtro-modal-item-input-forma-pagamento
              v-if="params.forma_pgto && params.forma_pgto.visible"
              v-model="params.forma_pgto.value"
              name="Forma pagamento"
              label="Forma pagamento"
              icon="mdi-mailbox"
              rules="required"
            />
          </template>
        </servico-list-filtro-modal-item>
        
      </v-card-text>
      <v-card-actions class="d-flex justify-space-between">
        <v-btn plain @click="$emit('close')">Cancelar</v-btn>
        <v-btn
          class="px-8"
          x-large
          color="primary"
          @click="search"
          :disabled="areSettingsEmpty || invalid"
          ><v-icon>mdi-database-search</v-icon>
          <span>Buscar</span>
        </v-btn>
      </v-card-actions>
    </validation-observer>
  </v-card>
</template>

<script>
import ContratoAPI from '@/services/tenants/contratos'

import { data } from './_data'
import { computed } from './_computed'
import { methods } from './_methods'

import ConferenciaListFiltroData from '@/components/financeiro/conferencia/conferencia-list/ConferenciaListFiltroData'
import ServicoListFiltroModalItem from '../ServicoListFiltroModalItem.vue'
import ServicoListFiltroModalItemInput from '../ServicoListFiltroModalItemInput.vue'
import ServicoListFiltroModalItemInputStatus from '../ServicoListFiltroModalItemInputStatus.vue'
import ServicoListFiltroModalItemServicos from '../ServicoListFiltroModalItemServicos.vue'
import ServicoListFiltroModalItemInputTransportadoras from '../ServicoListFiltroModalItemInputTransportadoras.vue'
import ServicoListFiltroModalItemInputCliente from '../ServicoListFiltroModalItemInputCliente.vue'
import ServicoListFiltroModalItemInputFormaPagamento from '../ServicoListFiltroModalItemInputFormaPagamento.vue'
import ServicoListFiltroModalItemInputFornecedor from '../ServicoListFiltroModalItemInputFornecedor.vue'
import ServicoListFiltroModalItemInputTerminal from '../ServicoListFiltroModalItemInputTerminal.vue'
import ServicoListFiltroModalItemInputProdutos from '../ServicoListFiltroModalItemInputProdutos.vue'
import ServicoListFiltroModalItemInputSubProdutos from '../ServicoListFiltroModalItemInputSubProdutos.vue'

export default {
  name: 'ServicoListFiltroModal',
  components: {
    ConferenciaListFiltroData,
    ServicoListFiltroModalItem,
    ServicoListFiltroModalItemInput,
    ServicoListFiltroModalItemInputStatus,
    ServicoListFiltroModalItemServicos,
    ServicoListFiltroModalItemInputTransportadoras,
    ServicoListFiltroModalItemInputCliente,
    ServicoListFiltroModalItemInputFornecedor,
    ServicoListFiltroModalItemInputTerminal,
    ServicoListFiltroModalItemInputProdutos,
    ServicoListFiltroModalItemInputSubProdutos,
    ServicoListFiltroModalItemInputFormaPagamento
  },
  data,
  computed,
  methods,
  async created() {
    this.settingFilters = true

    this.getParamsFilter()

    await this.getColaboradores()

    if (this.empresaAtual.gate) {
      this.params.gate.value = this.empresaAtual.public_id
      this.params.proprietario.value = ''
    } else {
      const { possible_gates } = await ContratoAPI.getPossiveisGates(
        this.empresaAtual.public_id
      )
      this.gates = possible_gates
      this.params.proprietario.value = this.empresaAtual.public_id
    }

    this.addParamsFilter()

    this.UPDATE_PARAMS(this.params)

    await this.showOnlySelectedOptionsAndGetItems()
    this.settingFilters = false
  },
}
</script>
